import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import usePageMeta from '../../utilities/usePageMeta';
import ArticlePage from './ArticlePage';
import contactBanner from '../../resources/css/images/contact-banner.jpg';

export default function ContactUs() {
    usePageMeta({
        title: 'Contact Us',
        description: 'Contact Executive Storage Suites at 2481 Executive Drive, East Troy, WI 53120. Call, email or stop by for climate controlled storage in Walworth County.',
        path: '/contact',
    });

    // The template put this in a #sidebar column of its grid. As a card it reads as the reference
    // panel it actually is, and it stays legible when the two columns stack on a phone.
    const contactDetails = (
        <Paper
            elevation={0}
            sx={{
                border: '1px solid rgba(0, 0, 0, 0.08)',
                borderRadius: 2,
                padding: { xs: '20px', md: '24px' },
                backgroundColor: '#fbfbfc',
            }}
        >
            <Typography variant={'h6'} component={'h2'} sx={{ fontWeight: 700, marginBottom: '14px' }}>
                Contact Information
            </Typography>

            <Box sx={{ '& p': { marginBottom: '1.1em' }, '& p:last-of-type': { marginBottom: 0 } }}>
                <p><b>Executive Storage Suites</b><br/>
                    2481 Executive Drive<br/>
                    East Troy, WI 53120</p>

                <p><b>Phone:</b> <a href="tel:+14146593045">(414) 659-3045</a><br/>
                    <b>Fax:</b> (262) 642-5395</p>

                <p><b>Email:</b> <a href="mailto:Sandynyff@yahoo.com">Sandynyff@yahoo.com</a></p>

                <p><b>Gate Access</b><br/>
                    24/7 Access</p>
            </Box>
        </Paper>
    );

    return (
        <ArticlePage
            title={'Contact Executive Storage Suites in East Troy, WI'}
            image={contactBanner}
            imageAlt={'The Executive Storage Suites facility in East Troy, Wisconsin'}
            imageWidth={1600}
            imageHeight={484}
            sidebar={contactDetails}
        >
            <p>Conveniently located less than one mile south of I-43, Executive Storage Suites offers quality and affordable East Troy, WI storage that is easy to get to from all local and surrounding areas. Our storage center is part of the East Troy Business Center, one half mile east of State Rd 120.</p>

            <h3>24-Hour Storage Center</h3>

            <p>Whether you are coming from Downtown, Mukwonago, Lake Geneva, Burlington or Elkhorn, you will find all you need for clean and secure storage in Walworth County at Executive Storage Suites. We offer 24-hour storage in a wide variety of different sizes with convenient monthly rental options to accommodate all belongings and budgets. Call, email or stop by to start storing with us today!</p>
        </ArticlePage>
    );
}
